import React from 'react';

const LinkForm = ({ url, message, copyRef }) => (
  <form className="save-send__tab-form">
    <div>
      <textarea
        ref={copyRef}
        className="form__control save-send__tab-textarea"
        cols="50"
        rows="4"
        defaultValue={url}
      />
    </div>
    <div>
      {message ? (
        <div
          className="save-send__copy-message"
          ng-show="saveSend.copySuccessful">
          {message}
        </div>
      ) : null}
    </div>
  </form>
);

export default LinkForm;
